import { render, staticRenderFns } from "./AromaInput.vue?vue&type=template&id=21ab364e"
import script from "./AromaInput.vue?vue&type=script&lang=js"
export * from "./AromaInput.vue?vue&type=script&lang=js"
import style0 from "./AromaInput.vue?vue&type=style&index=0&id=21ab364e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports